// Single source of truth for status → color mappings shown across the app.
// Keeps proposal/subscription/skill/audit badges visually consistent.

export const STATUS_COLORS = {
  // Generic
  active: "#16A34A",
  inactive: "#A8A29E",
  pending: "#C8A951",
  approved: "#16A34A",
  rejected: "#C61418",
  archived: "#A8A29E",
  // Proposals
  sent: "#3B7FE8",
  paid: "#16A34A",
  expired: "#A8A29E",
  canceled: "#C61418",
  // Subscriptions
  trialing: "#3B7FE8",
  past_due: "#C61418",
  incomplete: "#C8A951",
  incomplete_expired: "#A8A29E",
  unpaid: "#C61418",
  paused: "#A8A29E",
  // Members
  revoked: "#C61418",
  invited: "#C8A951",
  // Org
  suspended: "#C61418",
} as const satisfies Record<string, string>;

export function statusColor(status: string | null | undefined): string {
  if (!status) return "#A8A29E";
  return (STATUS_COLORS as Record<string, string>)[status] ?? "#A8A29E";
}
